import React from 'react';

import PropTypes from 'prop-types';
import {
  FaCheckCircle,
  FaUserCheck,
  FaHandshake,
  FaBolt,
  FaShieldAlt,
} from 'react-icons/fa';

import { useTranslation } from 'react-i18next';

import employerImage from '../../Assets/img/main.webp';
import WithBackground from '../Common/WithBackground';


import './style.css';

const EmployerAbout = ({ bg, overlay = 'dark' }) => {
  const { t } = useTranslation();

  const services = [
    {
      id: 1,
      icon: <FaCheckCircle />,
      title: t('employerAbout.services.verifiedCandidates.title'),
      description: t('employerAbout.services.verifiedCandidates.description'),
    },
    {
      id: 2,
      icon: <FaUserCheck />,
      title: t('employerAbout.services.individualApproach.title'),
      description: t('employerAbout.services.individualApproach.description'),
    },
    {
      id: 3,
      icon: <FaHandshake />,
      title: t('employerAbout.services.comprehensiveSupport.title'),
      description: t(
        'employerAbout.services.comprehensiveSupport.description'
      ),
    },
    {
      id: 4,
      icon: <FaBolt />,
      title: t('employerAbout.services.speedEfficiency.title'),
      description: t('employerAbout.services.speedEfficiency.description'),
    },
    {
      id: 5,
      icon: <FaShieldAlt />,
      title: t('employerAbout.services.transparencyTrust.title'),
      description: t('employerAbout.services.transparencyTrust.description'),
    },
  ];

  const aboutContent = (
    <section className='employer-about'>
      
      <div className='employer-about__container'>
        <div className='employer-about__intro'>
          <div className='employer-about__intro-grid'>
            <div className='employer-about__intro-content' data-aos="fade-right" data-aos-delay="100">
              <h2 className='employer-about__title'>{t('employerAbout.title')}</h2>
              <p className='employer-about__description'>
                {t('employerAbout.description')}
              </p>
            </div>
            <div className='employer-about__intro-image' data-aos="fade-left" data-aos-delay="200">
              <img
                src={employerImage}
                alt={t('employerAbout.imageAlt')}
                className='employer-about__image'
              />
            </div>
          </div>
        </div>

        <div className='employer-about__services'>
          <div
            className='services-header'
            data-aos='fade-up'
            data-aos-delay='300'
          >
            <h3 className='services-header__title'>
              {t('employerAbout.weOffer')}
            </h3>
          </div>

          <div className='services-grid'>
            {services.map((service, index) => (
              <div
                key={service.id}
                className='service-card'
                data-aos='fade-up'
                data-aos-delay={300 + index * 100}
              >
                <div className='service-card__icon'>{service.icon}</div>
                <h4 className='service-card__title'>{service.title}</h4>
                <p className='service-card__description'>
                  {service.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );

  return bg ? (
    <WithBackground bg={bg} overlay={overlay}>
      {aboutContent}
    </WithBackground>
  ) : (
    aboutContent
  );
};

EmployerAbout.propTypes = {
  bg: PropTypes.string,
  overlay: PropTypes.oneOf(['dark', 'light', 'golden', 'none']),
};

EmployerAbout.defaultProps = {
  bg: null,
  overlay: 'dark',
};

export default EmployerAbout;